import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActionSheetController, NavController } from 'ionic-angular';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/takeWhile';
import { Proband } from '../../data/data';
import { DataProvider } from '../../provider/data-service';
import { Settings, SettingsProvider } from '../../provider/settings-service';
import { RecordsProbandPage } from '../records/recordsSession/recordsProband';
import { SettingsPage } from '../settings/settings';
import { History } from './../../data/data';
import { InstructionsPage } from './../instructions/instructions';

@Component({
    selector: 'page-session',
    templateUrl: 'session.html'
})
export class SessionPage {

    public settings: Settings = null;
    public history: History = null;

    public proband: Proband;

    @ViewChild('container')
    container: ElementRef;

    constructor(
        public navCtrl: NavController,
        private actionSheetCtrl: ActionSheetController,
        private settingsProvider: SettingsProvider,
        private dataProvider: DataProvider
    ) {
        this.settings = this.settingsProvider.settings;
        this.history = this.dataProvider.history;

        if (this.history.probanden.length > 0) {
            this.proband = this.history.probanden[this.history.probanden.length - 1];
        } else {
            this.proband = this.history.newProband();
        }
    }

    public next(): void {
        this.proband = this.history.newProband();
    }

    public sessionsDone(): number {
        return this.proband.sessions.length;
    }

    public openRecords(): void {
        this.navCtrl.push(RecordsProbandPage, { proband: this.proband });
    }

    public openSettings(): void {
        this.navCtrl.push(SettingsPage);
    }

    public start(): void {
        this.dataProvider.save();
        this.navCtrl.push(InstructionsPage, { proband: this.proband });
    }

    public selectProband() {
        const buttons = [];
        this.history.probanden.forEach(p => {
            const txt = `Proband ${p.probandid}`;
            buttons.push({
                text: txt,
                handler: () => {
                    this.proband = p;
                }
            });
        });
        buttons.push({
            text: 'Abbruch',
            role: 'cancel', // will always sort to be on the bottom
            handler: () => {
            }
        });

        const actionSheet = this.actionSheetCtrl.create({
            title: 'Proband auswählen',
            buttons: buttons
        });
        actionSheet.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/session/session.ts